var render = function render(_c,_vm){return _c('svg',{attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){return _vm.listeners.click()}}},[_c('path',{attrs:{"d":"M19 19V5H5v14z","fill":"#F03861","fill-rule":"nonzero"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }